import { render, staticRenderFns } from "./UserTag.vue?vue&type=template&id=3e8b6662&scoped=true&"
import script from "./UserTag.vue?vue&type=script&lang=js&"
export * from "./UserTag.vue?vue&type=script&lang=js&"
import style0 from "./UserTag.vue?vue&type=style&index=0&id=3e8b6662&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8b6662",
  null
  
)

export default component.exports